import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RecordSwipperItem } from 'src/app/models/record-swiper';

@Component({
  selector: 'app-slider-list-item',
  templateUrl: './slider-list-item.component.html',
  styleUrls: ['../slider.component.scss'],
})
export class SliderListItemComponent {
  @Input()
  item: RecordSwipperItem;

  @Input()
  active: boolean;

  @Input()
  visible: boolean;

  @Output()
  clicked: EventEmitter<RecordSwipperItem> = new EventEmitter();

  onClicked() {
    this.clicked.emit(this.item);
  }
}
